import { render, staticRenderFns } from "./customers-frequency.vue?vue&type=template&id=1e90edf9&scoped=true"
import script from "./customers-frequency.vue?vue&type=script&lang=js"
export * from "./customers-frequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90edf9",
  null
  
)

export default component.exports